import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { useMenu } from '../../hooks/useMenu';
import useApplicationOwnerName from '../../hooks/useApplicationOwnerName';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { secureAccountDobTitle } from '../../util/helpers/onboardingContentHelpers';
import { HeadingSubtitle } from '../../components/Heading';
import Paragraph from '../../components/Paragraph/Paragraph';
import AccountDobForm from '../../components/Forms/AccountDobForm';
import themeColors from '../../assets/styles/themeColors';
import { selectSettings } from '../../store/selectors/settingsSelectors';

const SecureAccountDob = ({ applicantType }) => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const applicantName = useApplicationOwnerName(applicantType);
  const settings = useSelector(selectSettings);
  const { BrokerName } = settings;
  const formId = 'dob_form';
  const [eventType, setEventType] = useState(null);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem.previousPath}
      formId={formId}
      setEventType={setEventType}
    >
      <Helmet>
        <title>
          {t('titleTagDob', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <HeadingSubtitle color={themeColors.colorTextSecondary} mb={12}>
        {applicantType && secureAccountDobTitle(applicantType, applicantName)}
      </HeadingSubtitle>
      <Paragraph mb={32} color={themeColors.colorTextXLLight}>
        {t('secureDob.subtitle')}
      </Paragraph>
      <AccountDobForm
        applicantType={applicantType}
        nextPath={activeItem.nextPath}
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
      />
    </OnBoardingContainer>
  );
};

SecureAccountDob.propTypes = {
  applicantType: PropTypes.string,
};

export default SecureAccountDob;
